import PropTypes from 'prop-types';
import React from 'react';

import AppActions from '../../actions/AppActions';
import connectToStores from '../../helpers/connectToStores';
import BannerStore from '../../stores/BannerStore';
import BannerRecord from '../../records/Banner';

import Banner from './Banner';
import CroppedBannerMessage from './CroppedMessage';

export class MessageBanner extends React.PureComponent {

    static propTypes = {
        banner: PropTypes.instanceOf(BannerRecord)
    };

    static defaultProps = {
        banner: null
    };

    componentDidMount() {
        AppActions.loadBanner();
    }

    handleDismiss = () => {
        AppActions.dismissMessageBanner(this.props.banner.id);
    };

    render() {
        const { banner } = this.props;

        if (!banner) {
            return null;
        }

        const bannerProps = {
            className: 'banner--message',
            bodyClassName: 'body--banner-message',
            onDismiss: this.handleDismiss,
            showDismiss: true
        };

        const regex = /(<a\b[^>]*>)[^<>]*(<\/a>)/i;

        const getTextFromHyperlink = linkText => {
            if (!linkText || typeof linkText !== 'string') {
                return null;
            }

            const match = linkText.match(/<a [^>]+>([^<]+)<\/a>/);
            return match && match.length >= 2 ? match[1] : null;
        };

        let replacedBannerText = null;
        const hyperlinkText = getTextFromHyperlink(banner.text);

        if (hyperlinkText) {
            replacedBannerText = banner.text.replace(regex, `$1<span class="external-link">
                ${hyperlinkText}</span>
                <span class="external-link__spacer">&nbsp;</span>
                <i class="otrl otrl-externallink"></i>
                <span class="sr-only"> opens in a new window</span>$2`
            );
        }

        return (
            <Banner {...bannerProps}>
                <div className="pull-left">
                    <CroppedBannerMessage message={replacedBannerText || banner.text} />
                </div>
            </Banner>
        );
    }
}

function getStateFromStores() {
    return {
        banner: BannerStore.getActive()
    };
}

export default connectToStores([BannerStore], getStateFromStores)(MessageBanner);
